import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { HOVER_SPRING } from '../../utils/motion';
type NextCaseProps = {
  title: string;
  href: string;
};
export function NextCase({
  title,
  href
}: NextCaseProps) {
  return <Reveal className="mt-24" data-id="element-124" data-mp="qvqe3ilkysyu">
      <motion.div initial="rest" animate="rest" whileHover="hover" data-id="element-125" data-mp="1njwqiroqupno">
        <Link to={href} className="flex items-center justify-between gap-6 rounded-2xl bg-ink px-6 py-6 text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/40 focus-visible:ring-offset-4 md:px-8" data-id="element-126" data-mp="1nmajmuzv5rsl">
          <span data-id="element-127" data-mp="19tktqfh7s2q7">
            <span className="block text-xs text-white/70" data-id="element-128" data-mp="19s02ayq74zwk">Next case study</span>
            <span className="mt-1 block text-base font-semibold md:text-lg" data-id="element-129" data-mp="26axq9hxoup8a">{title}</span>
          </span>
          <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-white px-4 py-2 text-sm font-medium text-ink" data-id="element-130" data-mp="21iwdzw0isyi9">
            Next
            <motion.span variants={{
            rest: {
              x: 0
            },
            hover: {
              x: 3
            }
          }} transition={HOVER_SPRING} data-id="element-131" data-mp="2y118r2bn9wet">
              <ArrowRightIcon className="h-4 w-4" data-id="element-132" data-mp="32zm7exb90815" />
            </motion.span>
          </span>
        </Link>
      </motion.div>
    </Reveal>;
}